import { impactCo2Slice } from '../impact-co2.slice';

export const clearImpactCo2Answers =
  impactCo2Slice.actions.clearImpactCo2Answers;
